import './style.scss';
import NotificationPanel from '../../../NotificationPanel';

type Props = {
  subtitle: string;
  toggleChat: () => void;
  showCloseButton: boolean;
  title?: string;
  titleAvatar?: string;
  onSelectCommand: (command: string) => void;
  useButton: boolean;
}

function Header({ title, subtitle, toggleChat, showCloseButton, titleAvatar, onSelectCommand, useButton }: Props) {
  return (
    <div className="rcw-header" >
      <NotificationPanel />
      <div className='header-preview'>
        {Boolean(titleAvatar) && <img className='header-preview-icon' src={titleAvatar} alt="profile" />}
        <div>
          {Boolean(title) && <h4 className='header-preview-title'>{title}</h4>}
          <span className='header-preview-subtitle'>{subtitle}</span>
        </div>
      </div>
      {showCloseButton && <button className="rcw-close-button" onClick={toggleChat}>
        <span className="rcw-close">×</span>
      </button>}

    </div>
  );
}

export default Header;
